import Header from './components/Header.js';
import Carousel from './components/Carousel.js';
import Scrolly from './components/Scrolly.js';
import Modale from './components/Modale.js';
import Form from './components/Form.js';
import Tabs from './components/Tabs.js';
import YouTube from './components/YouTube.js';
import Parallax from './components/Parallax.js';
import ExperienceProjets from './components/ExperienceProjets.js';
import Divers from './components/Divers.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Carousel,
      Header,
      Scrolly,
      Modale,
      Form,
      Tabs,
      YouTube,
      //Parallax,
      ExperienceProjets,
      Divers
    };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
